import axios, { getData } from "lib/axios"

export const getAllStaff = async () => {
    return axios.get(`/admin-access`).then(getData)
}

export const getDepartmentList = async () => {
    return axios.get(`/department-list`).then(getData)
}

export const getDepartmentListById = async (id) => {
    return axios.get(`/department-list/${id}`).then(getData)
}

export const postDepartmentList = async (data) => {
    return axios.post(`/department-list`, data).then(getData)
}

export const putDepartmentList = async (id, data) => {
    return axios.put(`/department-list/${id}`, data).then(getData)
}

export const postHeadOfOrganization = async (data) => {
    return axios.post(`/organization-head`, data).then(getData)
}

export const postDepartmentLayer = async (data) => {
    return axios.post(`/department-layer`, data).then(getData)
}

export const deleteDepartmentLayer = async (id) => {
    return axios.delete(`/department-layer/${id}`).then(getData)
}

export const deleteDepartmentList = async (id) => {
    return axios.delete(`/department-list/${id}`).then(getData)
}


